import React, { useState } from 'react';
import './style.scss';
import { MenuButtonProps, middleMenuData, bottomMenuData } from 'views/utils/handlePath';
import { NavLink, useLocation } from 'react-router-dom';
import { IconColor, IconSize, SvgIcon } from 'views/components/atoms/svgIcon';
import { IconName, findIcon } from 'views/utils/handleIcon';
import Logo from 'assets/FPG_logo_securities_jp_blue.svg';
import { WhiteBorder } from 'views/components/atoms/separator';
import { CenterNav } from '../centerNav';
import { checkHeaderPath } from 'views/utils/checkHeaderPath';
import { ShowHeaderType } from 'views/constants/enums/ShowHeaderType';
import { LogoNavLink } from 'views/utils/logoNavLink';
import { useLeftNav } from './hook';
import { useClient } from 'urql';

export const MainLogo = () => {
  return <img className="mainLogo" src={Logo} alt="" />;
};

export const SideMenuPc = () => {
  const location = useLocation();
  return checkHeaderPath(location.pathname) === ShowHeaderType.Info ? (
    <div className="sideMenuPC">
      <NavLink to={LogoNavLink(location.pathname)} className="sideMenuPC_logo">
        <MainLogo />
      </NavLink>
      <div className="sideMenuPC_middle">
        {middleMenuData.map((item, i) => {
          return <MenuButton key={i} {...item} onClose={() => {}} />;
        })}
      </div>
      <div className="sideMenuPC_bottom">
        {bottomMenuData.map((item, i) => {
          return <MenuButton key={i} {...item} onClose={() => {}} />;
        })}
      </div>
    </div>
  ) : (
    <div className="sideMenuPC">
      <NavLink to={LogoNavLink(location.pathname) || ''} className="sideMenuPC_logo">
        <MainLogo />
      </NavLink>
    </div>
  );
};

export const SideMenuSP = () => {
  const icon = findIcon(IconName.Hamburger);

  const { location, isShown, toggle, hide } = useLeftNav();

  return checkHeaderPath(location.pathname) === ShowHeaderType.Info ? (
    <div className="sideMenuSP">
      <div className="sideMenuSP_header">
        <NavLink to={LogoNavLink(location.pathname) || ''} className="sideMenuSP_logo">
          <MainLogo />
        </NavLink>
        <label className="sideMenuSP_hamburger">
          <input type="checkbox" checked={isShown} onClick={toggle} />
          <SvgIcon icon={icon} size={IconSize.icon_l} color={IconColor.primary} />
        </label>
        {isShown && (
          <div className="sideMenuSP_overLay">
            <div className="sideMenuSP_space" onClick={hide}></div>
            <div className="sideMenuSP_list">
              <CenterNav />
              <WhiteBorder />
              <div className="sideMenuSP_wrapper">
                {middleMenuData.map((item, i) => {
                  return <MenuButton key={i} {...item} onClose={hide} />;
                })}
                {bottomMenuData.map((item, i) => {
                  return <MenuButton key={i} {...item} onClose={hide} />;
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="sideMenuSP">
      <div className="sideMenuSP_header">
        <NavLink to={LogoNavLink(location.pathname) || ''} className="sideMenuSP_logo">
          <MainLogo />
        </NavLink>
      </div>
    </div>
  );
};

const MenuButton = (props: MenuButtonProps & { onClose: () => void }) => {
  const { to, action, className, iconName, label, onClose } = props;
  const icon = findIcon(iconName);
  const client = useClient();

  return (
    <NavLink
      to={to}
      className={className}
      onClick={(_) => {
        action && action(client);
        onClose();
      }}
    >
      <div className="menuButton isActive">
        <SvgIcon icon={icon} size={IconSize.icon_m} color={IconColor.primary} />
        <span className="menuButton_label">{label}</span>
      </div>
    </NavLink>
  );
};
